// extracted by mini-css-extract-plugin
export default {"page-container":"InventoryItem_page-container__GaSFg"};